import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";

const Account = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});
    
    let response64 = useInvoke("WebApps", "64", {});

    const[rows, setRows] = useState([]);
    const[columns, setColumns] = useState([]);

    useEffect(() => {

        //get user list
        if (response64.data.payload != undefined) {
            let myData = JSON.parse(response64.data.payload).data;
            let rowsList = [];

            myData.forEach((entry, index) => { 

              let row = [
                {type: "link", content: {text: `${entry[3]}`, link: `/Account/Edit/${entry[0]}`}}, 
                {type: "text", content: {text: `${entry[1]}`}},
                {type: "text", content: {text: `${entry[2]}`}},
                {type: "text", content: {text: `${entry[5]}`}},
                {type: "text", content: {text: `${entry[4]}`}}
              ];
              rowsList.push(row);
            });

            setColumns(["Email", "First Name", "Last Name", "Role", "Must Change Password"]);
            setRows(rowsList);

        }

    }, [response64.data.payload]);

    document.title = "Accounts";
    return ( 
        <div className="Accounts">
            {user["email"] != undefined && 
                <div className="container" style={{margin: "auto"}}>
                    <h2>Accounts</h2>
                    <p><Link className="btn btn-primary" to="/Account/New">New Account</Link></p>
                
                    {(columns && rows) && <DynamicGrid columnNames={columns} tableData={rows} sortable={true} />}

                </div>
            }
        </div>
     );
}
 
export default Account;